//
//
//
//
//
//
//
//


export default {

    name: 'Loading',

    props: {
        loaderClass: {
            type: String,
            default: ''
        },
        triggerScroll: {
            type: Boolean,
            default: false
        }
    },

    created() {
        if(process.client && this.triggerScroll) {
            //console.log('triggerScroll')
            this.$nuxt.$nextTick(() => this.$nuxt.$emit('triggerScroll'))
        }
    },

    activated() {
        if(process.client && this.triggerScroll) {
            //console.log('triggerScroll')
            this.$nuxt.$nextTick(() => this.$nuxt.$emit('triggerScroll'))
        }
    }
}

